import React from 'react'
import { BANKING_BOTTOM_CONTENT, SOFTWARE_COURSE_PAGE_3, SOFTWARE_DETAILS_PAGE_3, SOFTWARE_HERO_PAGE_3 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { SOFTWARE_ACCORDIAN_3 } from '../../../utils/courseConifg'

const SoftwarePage_3 = () => {
  return (
    <div className='outlet-render'>
        <CourseAsideHero  {...SOFTWARE_HERO_PAGE_3}/>
     <CoursesAside {...SOFTWARE_COURSE_PAGE_3}/>
     <CourseCard {...SOFTWARE_DETAILS_PAGE_3}/>
     <Accordian {...SOFTWARE_ACCORDIAN_3}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default SoftwarePage_3